import React from 'react';
import { useQuery } from 'react-query';

import { Box, Button, Chip, Grid, Typography } from '@material-ui/core';
import { format } from 'date-fns';

import { ReactComponent as CalendarIcon } from '../../../../../assets/img/icon/Calendar.svg';
import { ReactComponent as ClockIcon } from '../../../../../assets/img/icon/Clock.svg';
import { ReactComponent as DownloadIcon } from '../../../../../assets/img/icon/Download.svg';
import { ReactComponent as LocationIcon } from '../../../../../assets/img/icon/Location.svg';
import SubHeader from '../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../components/LoaderSplash/Loader.component';
import {
  INCIDENTS_QUERY_CONFIG,
  incidentQuery,
} from '../../../../../query/incidents/incidents';
import useIncidentState from './hooks';

const IncidentDetails = () => {
  const { loading, incident: incidentDetails } = useIncidentState();

  const { data: incident, isLoading } = useQuery(
    ['incident_detail', { id: incidentDetails.id }],
    incidentQuery,
    INCIDENTS_QUERY_CONFIG
  );

  return (
    <>
      <Box display={isLoading || loading ? 'block' : 'none'}>
        <Loader action={'Cargando denuncia'}></Loader>
      </Box>

      <SubHeader
        content={
          <Box>
            <Typography variant="h6"> Detalle de la denuncia </Typography>
          </Box>
        }
        actions={
          <Grid container>
            <Grid item xs={12}>
              <Box style={{ textAlign: 'end' }}>
                <Button color="primary" onClick={() => window.print()}>
                  <DownloadIcon />
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SubHeader>

      {/* Header */}
      <Grid container justify="center">
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: '#FAFAFA',
            paddingLeft: '24px',
            paddingRight: '24px',
          }}
        >
          <Box>
            <Box mt={3}>
              <Typography variant="caption">
                {incident?.number
                  ? `Nro de siniestro: #${incident?.number}`
                  : null}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="h6"> {incident?.incident_type} </Typography>
            </Box>

            <Box my={2} display="flex" alignItems="center">
              {incident?.address && <LocationIcon /> /* {' '} */}
              <Box ml={2}>
                {incident?.address && (
                  <Typography> {incident?.address} </Typography>
                )}
              </Box>
            </Box>

            <Box
              mt={2}
              mb={3}
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                columnGap: '36px',
              }}
            >
              <Box display="flex" alignItems="center">
                <CalendarIcon />{' '}
                <Box ml={2}>
                  <Typography>
                    {incident?.date &&
                      (incident?.date).split('-').reverse().join('/')}
                  </Typography>
                </Box>
              </Box>
              <Box display="flex" alignItems="center">
                <ClockIcon />{' '}
                <Box ml={2}>
                  <Typography> {incident?.time && incident.time} </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Basic information */}
      <Grid container justify="center">
        <Grid item xs={11}>
          <Box my={3}>
            <Box>
              <Box>
                <Box my={2}>
                  <Typography variant="subtitle2"> Vehículo </Typography>
                  <Typography>{`${incident?.item?.brand} ${incident?.item?.model} - Patente ${incident?.item?.license_plate}`}</Typography>
                </Box>
              </Box>

              <Box>
                {incident?.incident_type && (
                  <Box my={2}>
                    <Typography variant="subtitle2">
                      {' '}
                      Tipo de siniestro{' '}
                    </Typography>
                    <Typography> {incident?.incident_type} </Typography>
                  </Box>
                )}
              </Box>

              <Box>
                {incident?.description && (
                  <Box my={2}>
                    <Typography variant="subtitle2">
                      {' '}
                      Descripción del hecho{' '}
                    </Typography>
                    <Typography> {incident?.description} </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Claims */}
            <Box
              my={4}
              style={{ paddingTop: '16px', borderTop: '1px solid #C4C4C4' }}
            >
              <Typography component="span" variant="subtitle2">
                {' '}
                Reclamos{' '}
              </Typography>

              <Box>
                {incident?.incident_claims?.map((claim: any) => (
                  <Box
                    mb={3}
                    style={{
                      paddingBottom: '32px',
                      borderBottom: '1px solid #C4C4C4',
                    }}
                  >
                    <Box
                      mt={2}
                      mb={3}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                      }}
                    >
                      <Box>
                        <Box>
                          <Typography
                            display="block"
                            component="span"
                            variant="h3"
                            color="textSecondary"
                          >
                            {claim?.description}
                          </Typography>
                        </Box>
                        <Box mt={1}>
                          {Array.isArray(claim?.tracking) &&
                            claim?.tracking.length > 0 && (
                              <Typography color="secondary" variant="h4">
                                {claim?.tracking[0]?.type +
                                  ' | ' +
                                  format(
                                    new Date(claim?.tracking[0]?.date),
                                    'dd/MM/yyyy'
                                  )}
                              </Typography>
                            )}
                        </Box>
                      </Box>
                      <Box m={1}>
                        <Chip
                          style={{ borderRadius: '3px' }}
                          variant="outlined"
                          label={claim?.status}
                          size="small"
                        />
                      </Box>
                    </Box>
                    <Box>
                      <Typography>{claim?.tracking[0]?.description}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default IncidentDetails;
